import '@/scss/main.scss';
import '@mdi/font/css/materialdesignicons.css';

import Vue from 'vue';
import Buefy from 'buefy';
import App from './App.vue';
import router from './router';
import store from './store';

/* Vue. Component in recursion */
import AsideMenuList from '@/modules/core/components/AsideMenuList.vue';
import ConfigService from './config';

import { format } from 'date-fns';
import { DateFormat } from './date_format';
import { VueSuperMethod } from './vue-super';
import AuthenticationService from './auth.service';
import { PermissionType, RoleType } from '@shared/common/types';
import { validationMessages } from '@shared/common/validation-messages';
import { validationConfiguration } from '@lgce/class-validator';
import 'reflect-metadata';
import { VNode } from 'vue/types/umd';
import PortalVue from 'portal-vue';

Vue.use(PortalVue);

/* Collapse mobile aside menu on route change */
router.afterEach(() => {
  store.commit('asideMobileStateToggle', false);
});

Vue.config.productionTip = false;

/* These components are used in recursion algorithm */
Vue.component('AsideMenuList', AsideMenuList);


Vue.use(Buefy, {
  defaultMonthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
  defaultDayNames: ['D', 'L', 'Ma', 'Mer', 'J', 'V', 'S'],
  defaultFirstDayOfWeek: 1,
});

Vue.prototype.$super = VueSuperMethod;

Vue.prototype.$is = (roles: RoleType | RoleType[]): boolean => {
  if (AuthenticationService.user) {
    return AuthenticationService.user.is(roles);
  }

  return false;
};

Vue.prototype.$can = (permissions: PermissionType | PermissionType[]): boolean => {
  if (AuthenticationService.user) {
    return AuthenticationService.user.can(permissions);
  }

  return false;
};

Vue.prototype.$isAdmin = (): boolean => {
  if (AuthenticationService.user) {
    return AuthenticationService.user.isAdmin();
  }

  return false;
};

Vue.prototype.$auth = AuthenticationService;

Vue.prototype.$goBack = function $goBack(): void {
  this.$router.go(-1);
};

Object.defineProperty(Vue.prototype, '$user', {
  get: () => AuthenticationService.user,
});

const dateFilter = (date: string | Date, dateFormat = DateFormat.DEFAULT): string => {
  if (!date) { return 'N/A'; }

  if (typeof date === 'string') {
    date = new Date(date);
  }

  if (dateFormat === DateFormat.ISO) {
    return date.toISOString();
  }

  return format(date, dateFormat);
};

Vue.filter('date', dateFilter);
Vue.filter('dateFull', (date: string | Date) => dateFilter(date, DateFormat.FULL));

// Set up global validation messages
validationConfiguration.setMessages(validationMessages);

const bootstrap = async (): Promise<void> => {
  await ConfigService.fetchConfig();

  // Vue.use(new VueSocketIO({
  //   debug: true,
  //   connection: 'http://localhost:3001', //ConfigService.config.PLATFORM_URL,
  // }));

  new Vue({
    router,
    store,
    render: (h): VNode => h(App),
  }).$mount('#app');
};

bootstrap();
